module.exports = __webpack_public_path__ + "static/music-video-contest.c96ab94e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/music-video-contest.pdf
// module id = 345
// module chunks = 35783957827783